import { render } from "./StoreGoodsTable.vue?vue&type=template&id=21c3b0c5"
import script from "./StoreGoodsTable.vue?vue&type=script&lang=js"
export * from "./StoreGoodsTable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__